import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import NowOverlay from '../components/NowOverlay';
import { getNowEntries, filterNowEntries, NOW_PLACEMENT_START } from '../api/api';
import './Home.css'; // Import your CSS file for the slideshow
import homeImage1 from '../assets/images/home-image-1.jpg';

// Ablauf der Startseite: erst nur das Foto, dann das NOW-Overlay darueber,
// danach ohne Eingabe automatisch weiter zur Karte
const PHOTO_MS = 2000;
const OVERLAY_MS = 4000;
// Antwortet Strapi nicht, geht es nach dieser Wartezeit ohne Overlay weiter
const NOW_TIMEOUT_MS = 3000;

const Home = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  // true, sobald das Foto lange genug allein zu sehen war
  const [photoDone, setPhotoDone] = useState(false);
  // NOW-Beitraege mit Anzeigeort "Startseite", als Overlay ueber dem Startfoto
  const [nowEntries, setNowEntries] = useState([]);
  // true, sobald feststeht, ob es NOW-Beitraege gibt (oder die Abfrage zu lange dauert)
  const [nowReady, setNowReady] = useState(false);
  // true, sobald der Besucher im Overlay irgendetwas getan hat: dann bleibt
  // es offen, bis es geschlossen wird
  const [userActive, setUserActive] = useState(false);

  const showOverlay = photoDone && nowEntries.length > 0;

  useEffect(() => {
    const timer = setTimeout(() => setPhotoDone(true), PHOTO_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let cancelled = false;

    getNowEntries().then(data => {
      if (cancelled) return;
      setNowEntries(filterNowEntries(data?.data, NOW_PLACEMENT_START));
      setNowReady(true);
    });

    const fallback = setTimeout(() => setNowReady(true), PHOTO_MS + NOW_TIMEOUT_MS);

    return () => {
      cancelled = true;
      clearTimeout(fallback);
    };
  }, []);

  useEffect(() => {
    if (!showOverlay) return;

    // Jede Eingabe haelt den automatischen Wechsel an
    const stop = () => setUserActive(true);
    const events = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
    events.forEach(name => document.addEventListener(name, stop, { passive: true }));
    return () => {
      events.forEach(name => document.removeEventListener(name, stop));
    };
  }, [showOverlay]);

  useEffect(() => {
    if (!photoDone || !nowReady || userActive) return;
    const timer = setTimeout(() => navigate('/map'), showOverlay ? OVERLAY_MS : 0);
    return () => clearTimeout(timer);
  }, [photoDone, nowReady, userActive, showOverlay, navigate]);

  const goToMap = () => {
    navigate('/map'); // Navigate to the map page on click
  };

  return (
    <div>
      {/* Full-screen image */}
      <div className="home-container" onClick={goToMap}>
        <div
          className="home-image"
          style={{
            backgroundImage: `url(${homeImage1})`,
          }}
        />
      </div>
      <NowOverlay
        entries={showOverlay ? nowEntries : []}
        onClose={goToMap}
        lightBackdrop
      />
    </div>
  );
};

export default Home;
